// extracted by mini-css-extract-plugin
module.exports = {"main":"IntroSection_main__Zn_L5","content":"IntroSection_content__xUeol"};